namespace GeniuzPOS.PosShift {
    export class PaymentTypeColumns {
        static columnsKey = 'PosShift.PaymentType';
    }
}
